import React from 'react';
import { Image } from '../Image/Image.es.js';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import 'nanoid/non-secure';
import { FeatureCardMedia } from './styled.es.js';

var Media = function Media(_ref) {
  var src = _ref.src,
      fallbackSrc = _ref.fallbackSrc,
      alt = _ref.alt,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height;
  return (
    /* @__PURE__ */
    React.createElement(FeatureCardMedia, null,
    /* @__PURE__ */
    React.createElement(Image, {
      src: src,
      fallbackSrc: fallbackSrc,
      width: width,
      height: height,
      alt: alt
    }))
  );
};

Media.displayName = "FeatureCard.Media";
export { Media };